import Foundation from "foundation-sites";
import $ from "jquery";
$(document).foundation();

$(document).ready(function ($) {
  // Initialize new Swiper on each .swiper-container
  var swiper = new Swiper('.about-swiper', {
    spaceBetween: 30,
    effect: 'fade',
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    speed: 1500,
    autoplay: {
      delay: 1500,
    }
  });
  $(".off-canvas a").on("click", function () {
    $(".off-canvas").foundation("close");
    $("#nav-icon3").toggleClass("open");
  });
  $("#nav-icon3").click(function () {
    $(this).toggleClass("open");
  });
});
